import script from "./ContextMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContextMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ContextMenu.vue?vue&type=style&index=0&id=3a82b80b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a82b80b"]])

export default __exports__